import { CmsNews } from './cms-news';

export class Article {
  title: string;
  subtitle: string;
  image: { data: any[] };
  description: string;
  documents: any[];
  constructor(data: CmsNews['data']['articles']['data'][0]) {
    this.title = data.attributes.title;
    this.subtitle = data.attributes.subtitle;
    this.image = data.attributes.image;
    this.description = data.attributes.description;
    this.documents = data.attributes.documents;
  }
}
